/* @ngInject */
function focusWhen($timeout) {
  return {
    scope: {
      focusWhen: '=',
    },
    link: function ($scope, $element) {
      $scope.$watch('focusWhen', function (shouldFocus) {
        if (shouldFocus) {
          $timeout(function () {
            $element[0].focus();
            $element.trigger('click');
          });
        }
      });
    },
  };
}

export default focusWhen;
